import queryString from 'query-string'

import { ALL_COMPANIES_OPTION } from 'utils/partnerUtils'
import { URL_CONST } from 'utils/urlConsts'

export const isIncidentsPage = (pathname) =>
  [URL_CONST.incidents.incidents, URL_CONST.incidents.atoIncidents].some((path) =>
    pathname.startsWith(`${path}/`)
  )

export const syncCompanyFilterToUrl = ({
  history,
  location,
  companyFilter,
  selfCompanyId,
  honorIncoming = false,
}) => {
  if (!companyFilter || isIncidentsPage(location.pathname)) return

  const qs = queryString.parse(location.search)
  if (honorIncoming && qs.companyFilter !== undefined) {
    if (String(qs.companyFilter) !== String(companyFilter.value)) return
  }
  const isChildSelected =
    companyFilter.value !== selfCompanyId && companyFilter.value !== ALL_COMPANIES_OPTION.value
  if (isChildSelected) {
    if (String(qs.companyFilter) === String(companyFilter.value)) return
    history.replace({
      pathname: location.pathname,
      search: `?${queryString.stringify({ ...qs, companyFilter: companyFilter.value })}`,
      state: location.state,
    })
  } else if (qs.companyFilter !== undefined) {
    const { companyFilter: _removed, ...rest } = qs
    const search = queryString.stringify(rest)
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : undefined,
      state: location.state,
    })
  }
}
